var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('ModalLayout',{attrs:{"title":_vm.title,"mStyle":'width:800px;height:700px; padding:0',"noFooter":true,"full":true},on:{"close":_vm.handleClose}},[_c('TotalSystem',{attrs:{"isModal":true,"menuName":_vm.menuName}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }